import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleUp,
  faBan,
  faBookOpen,
  faEye,
} from "@fortawesome/free-solid-svg-icons";

function StudentRow({ student, onView, onSuspend, index }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleViewCourses = (e) => {
    e.stopPropagation();
    setOpen(false);
    navigate(`/admin/user-management/${student.id}/courses`);
  };

  return (
    <div
      ref={ref}
      className="hover-actions-wrapper"
      style={{
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className={`hover-actions-trigger ${open ? "active" : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        Actions <span style={{ fontSize: "11px" }}>▾</span>
      </button>
      {open && (
        <div className="hover-actions-popup">
          <button
            className="hover-action-item"
            onClick={(e) => {
              e.stopPropagation();
              onView(student);
              setOpen(false);
            }}
          >
            <FontAwesomeIcon icon={faEye} className="action-icon" /> View Details
          </button>
          <button className="hover-action-item" onClick={handleViewCourses}>
            <FontAwesomeIcon icon={faBookOpen} className="action-icon" /> View Courses / Progress
          </button>
          <div className="hover-action-divider" />
          {student.isActive ? (
            <button
              className="hover-action-item text-danger"
              onClick={(e) => {
                e.stopPropagation();
                onSuspend(student);
                setOpen(false);
              }}
            >
              <FontAwesomeIcon icon={faBan} className="action-icon" /> Suspend
            </button>
          ) : (
            <button
              className="hover-action-item text-success"
              onClick={(e) => {
                e.stopPropagation();
                onSuspend(student);
                setOpen(false);
              }}
            >
              <FontAwesomeIcon icon={faAngleUp} className="action-icon" /> Reactivate
            </button>
          )}
        </div>
      )}
      <span
        style={{
          fontSize: "11px",
          color: "#94a3b8",
          alignSelf: "center",
          marginLeft: "8px",
        }}
      >
        #{index + 1}
      </span>
    </div>
  );
}

export default StudentRow;